import { render, staticRenderFns } from "./AppointmentListCard.vue?vue&type=template&id=4ce8f1d9"
import script from "./AppointmentListCard.vue?vue&type=script&lang=js"
export * from "./AppointmentListCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports